import Default from "components/layouts/Guest/Default";
import SelectSubject from "components/templates/SelectSubject/SelectSubject";

const App = () => (
  <Default>
    <SelectSubject />
  </Default>
);

export default App;
